import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { DFFieldValidate } from 'app/df-management/shared/df-master-data.model';

@Component({
  selector: 'app-df-optional-charges',
  templateUrl: './df-optional-charges.component.html',
  styleUrls: ['./df-optional-charges.component.scss']
})
export class DfOptionalChargesComponent implements OnInit {

  @Input() optionalAmountControls: AbstractControl[];
  @Input() chargeCodeValidate: DFFieldValidate;

  constructor() { }

  ngOnInit(): void {
  }

}
